import React from 'react';
import './CtaSection.css'; // Import the component-specific styles
import { useNavigate } from 'react-router-dom';

function CtaSection() {
  const navigate = useNavigate();

  const handleBookArchana = () => {
    navigate('/services');
  };

  return (
    // Converted HTML to JSX (class -> className)
    <section className="cta-section">
      <div className="section-inner">
        <h2 className="cta-title">Connect with the Divine Today</h2>
        <p className="cta-subtitle">Experience the spiritual fulfillment of authentic Hindu religious services from the comfort of your home.</p>
        <div className="cta-button-wrapper">
          <button className="btn cta-button btn-xl" onClick={handleBookArchana}>Book Archana Now</button>
        </div>
      </div>
    </section>
  );
}

export default CtaSection;
